<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import useSchoolYear from '~/composables/useSchoolYear'
import { useAssignTask } from '~/composables/useAssignTask'
import { EXAM_TAG } from '~/composables/useAssignTags'
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'
import AuCallout from '~/components/ui/AuCallout.vue'
import AssignedTaskCard from '~/components/cards/AssignedTaskCard.vue'

const { t } = useI18n()
const { currentSchoolYearCodeApi } = useSchoolYear()

const { tasks, isLoading, isError } = useAssignTask({
  tags: [EXAM_TAG],
  additionalParams: computed(() => ({
    schoolYear: currentSchoolYearCodeApi
  }))
})

const filteredTasks = computed(() => tasks?.value ?? [])
</script>

<template>
  <AuSkeletonWrapper v-if="isLoading">
    <AuSkeleton height="70px" />
    <AuSkeleton height="70px" />
    <AuSkeleton height="70px" />
  </AuSkeletonWrapper>
  <div
    v-else-if="isError"
    v-text="t('assign.error')"
  />
  <div v-else-if="!filteredTasks?.length">
    <AuCallout
      variant="info"
      :title="t('assign.student.infoTitle')"
    >
      <p v-text="t('assign.student.infoMessage')" />
    </AuCallout>
  </div>
  <ul
    v-else
    class="grid grid-cols-1 gap-2"
  >
    <AssignedTaskCard
      v-for="task in filteredTasks"
      :key="`task-${task.taskId}`"
      :task
    />
  </ul>
</template>
